import React, { useState } from "react";
import './PhotoItem.css';

const PhotoItem = ({ photo }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const handleImageLoad = () => {
        setIsLoaded(true);
    };

    const handleImageError = () => {
        setError(true);
        setIsLoaded(true);
    };

    const allowScroll = () => {
        const e1 = document.body;
        e1.classList.remove('no-scroll');
        const e2 = document.getElementById('root');
        e2.classList.remove('no-scroll');
    }

    const noScroll = () => {
        const e1 = document.body;
        e1.classList.add('no-scroll');
        const e2 = document.getElementById('root');
        e2.classList.add('no-scroll');
    }

    // FOR LIGHTBOX
    const openLightBox = (photo) => {
        noScroll();
        setSelectedPhoto(photo);
    };
    const closeLightBox = (photo) => {
        allowScroll();
        setSelectedPhoto(null);
    };
    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            allowScroll();
            closeLightBox();
        }
    };

    return (
        <div className="photo-item-wrap">
            <div className="photo-item"
                onClick={() => openLightBox(photo)}>
                {!isLoaded && <div className="photo-placeholder"></div>}
                {error ? (
                    <div className="photo-error">LOADING ERROR</div>
                ) : (
                    <img
                        src={photo.url}
                        alt={photo.name}
                        onLoad={handleImageLoad}
                        onError={handleImageError}
                        style={{ display: isLoaded ? 'block' : 'none' }}
                    />
                )}
                {/* <div className="photo-caption">{photo.alt}</div> */}
            </div>
            {/* Lightbox */}
            {selectedPhoto && (
                <div className="lightbox" onClick={handleBackdropClick}>
                    <div className="lb-wrap" onClick={handleBackdropClick}>
                        {/* Close Button */}
                        <button
                            onClick={closeLightBox}
                            className="lb-close-btn"
                        >
                            CLOSE
                        </button>
                        <img
                            className="lb-img"
                            src={photo.url}
                            alt={photo.name}
                            onLoad={handleImageLoad}
                            onError={handleImageError}
                            // style={{ display: isLoaded ? 'block' : 'none' }}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default PhotoItem;